import { Form, useParams } from "react-router-dom";
import {
    Container,
    Input,
} from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import starw from '../../../../assets/images/starw.png';
import info from '../../../../assets/images/info.png';
import projo from '../../../../assets/images/projo.png';
import projoi from '../../../../assets/images/projo1.png';
import five from '../../../../assets/images/fivepri.png';
import './addProductMobile.scss';
import AddproductimaegModal from "./Components/Addproductimaegmodal";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const AddProductMobile = (props: any) => {
    document.title = "Add Product | BuyPass";
    const { id, } = useParams();

    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);

    return (
        <div className="page-content">
            <AddproductimaegModal isOpen={modalOpen} toggle={toggleModal}/>
            <Container fluid>
                <BreadCrumb title={id ? "Edit Product" : "Add Product"} pageTitle="Products" pageTitleRoute="/manage-products" />
                <div className="addProductMianDv">
                    <h3>Product Info</h3>
                    <div className="borderDvProduct"></div>
                    <div className="productCard">
                        <div className="mediaSection">
                            <div className="productimg" onClick={toggleModal}>
                                <div className="textproduct">
                                    <h2>Product Images *</h2>
                                    <img src={info} />
                                </div>
                                <div className="imguploder">
                                    <img src={projo} />
                                    <h4>Upload or Drop file here. </h4>
                                    <h5>Max file size: 10 MB</h5>
                                </div>
                            </div>

                            <div className="productimg">
                                <div className="textproduct">
                                    <h2>Product Images *</h2>
                                    <img src={info} />
                                </div>
                                <div className="imguploder">
                                    <img src={projoi} />
                                    <h4>Upload or Drop file here. </h4>
                                    <h5>Max file size: 10 MB</h5>
                                </div>
                            </div>

                        </div>
                        <div className="fiveimg">
                            <div className="imageUpodCrad"><img src={five} /></div>
                            <div className="imageUpodCrad"><img src={five} /></div>
                            <div className="imageUpodCrad"><img src={five} /></div>
                            <div className="imageUpodCrad"><img src={five} /></div>
                            <div className="imageUpodCrad"><img src={five} /></div>
                            <div className="imageUpodCrad"><img src={five} /></div>
                           
                        </div>
                        <form>
                            <div className="AiDv">
                                <div className="formContainer">
                                    <label className="form-label" htmlFor="password-input">
                                        <span className="text-danger me-1">*</span>Product Name
                                    </label>
                                    <div className="position-relative auth-pass-inputgroup">
                                        <Input
                                            className="form-control"
                                            placeholder="Coolpix A300 Digital Came"
                                            data-testing-Id="passwordInput_login"
                                            type="text"
                                        />
                                        <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                    </div>
                                </div>
                                <div className="yellowbox">
                                    <div className="topheading">
                                        <div className="aibypass">
                                            <img src={starw} />
                                            <h5>Suggested by Buypass AI</h5>
                                        </div>
                                        <img src={info} />
                                    </div>
                                    <div className="medilheading">
                                        <h2>Nikon Coolpix A300 – Compact Power, Stunning Shots</h2>
                                    </div>
                                    <div className="bottomheading">
                                        <button>Use this title</button>
                                    </div>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Category
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input
                                        className="form-control"
                                        placeholder="Select category or search with keyword"
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                        onFocus={() => navigate("/product/add/categories")}
                                    />
                                    <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                </div>
                            </div>
                            <div className="AiDv">
                                <div className="formContainer">
                                    <label className="form-label" htmlFor="password-input">
                                        <span className="text-danger me-1">*</span>Main Description
                                    </label>
                                    <div className="position-relative auth-pass-inputgroup">
                                        <Input
                                            className="form-control"
                                            placeholder="Input Here"
                                            data-testing-Id="passwordInput_login"
                                            type="text"
                                        />
                                        <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                    </div>
                                </div>
                                <div className="yellowbox">
                                    <div className="topheading">
                                        <div className="aibypass">
                                            <img src={starw} />
                                            <h5>Suggested by Buypass AI</h5>
                                        </div>
                                        <img src={info} />
                                    </div>
                                    <div className="medilheading">
                                        <h2>Nikon Coolpix A300 Digital Camera
                                            Pocket-sized and powerful, the Nikon Coolpix A300 is your go-to camera for capturing life’s everyday moments in stunning detail. With a sharp... <span>Read More</span></h2>
                                    </div>
                                    <div className="bottomheading">
                                        <button>Use this description</button>
                                    </div>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Brand
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input
                                        className="form-control"
                                        placeholder="MD Trade"
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                    />
                                    <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Attributes
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input

                                        className="form-control"
                                        placeholder="Attributes "
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                        onFocus={() => navigate("/product/add/attributes")}
                                    />
                                    <div className="seleDv">
                                        <p>Set</p>
                                        <i className='bx  bx-caret-left iconDV'></i>
                                    </div>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Age Range
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input

                                        className="form-control"
                                        placeholder="Select"
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                    />
                                    <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Occasion
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input

                                        className="form-control"
                                        placeholder="Not Specified "
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                    />
                                    <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Variant
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input

                                        className="form-control"
                                        placeholder="Variant"
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                        onFocus={() => navigate("/product/add/Variants")}
                                    />
                                    <div className="seleDv">
                                        <p>Add Variations</p>
                                        <i className='bx  bx-caret-left iconDV'></i>
                                    </div>
                                </div>
                            </div>
                            <div className="AiDv">
                                <div className="kgdi">
                                    <div className="formContainer">
                                        <label className="form-label" htmlFor="password-input">
                                            <span className="text-danger me-1">*</span>Package Weight
                                        </label>
                                        <div className="position-relative auth-pass-inputgroup">
                                            <Input
                                                style={{ width: "200px" }}

                                                className="form-control"
                                                placeholder="Enter pkg weight"
                                                data-testing-Id="passwordInput_login"
                                                type="text"
                                            />
                                            <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                        </div>
                                    </div>
                                    <div className="formContainer">
                                        <div className="position-relative auth-pass-inputgroup">
                                            <Input
                                                style={{ width: "90px" }}

                                                className="form-control"
                                                placeholder="Kg"
                                                data-testing-Id="passwordInput_login"
                                                type="text"
                                            />
                                            <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="yellowbox">
                                    <div className="topheading">
                                        <div className="aibypass">
                                            <img src={starw} />
                                            <h5>Suggested by Buypass AI</h5>
                                        </div>
                                        <img src={info} />
                                    </div>
                                    <div className="medilheading">
                                        <h2>0.5 kg</h2>
                                    </div>
                                    <div className="bottomheading">
                                        <button>Use this weight</button>
                                    </div>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Price
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input

                                        className="form-control"
                                        placeholder="Ex. Rs. 1000"
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                    />
                                    <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Stock
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input

                                        className="form-control"
                                        placeholder="100"
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                    />
                                    <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Special Price
                                </label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input

                                        className="Special Price"
                                        placeholder="100"
                                        data-testing-Id="passwordInput_login"
                                        type="text"
                                    />
                                    <i className='bx  bx-caret-left lefticonInfoDv'></i>
                                </div>
                            </div>
                            <div className="formContainer">
                                <label className="form-label" htmlFor="password-input">
                                    <span className="text-danger me-1">*</span>Availability
                                </label>
                                <div className="position-relative auth-pass-inputgroup toggleButton">
                                    <p>Availability</p>
                                    <div className="form-check form-switch p-0">
                                        <input type="checkbox" className="form-check-input" id="flexSwitchCheckChecked" checked />
                                    </div>
                                </div>
                            </div>
                            <div className="chekBoxDv">
                                <div className="headingDv">Dangerous Goods <span><img src={info} alt="" /></span></div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked />
                                    <label className="form-check-label" htmlFor="exampleRadios1">
                                        None
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option2" checked />
                                    <label className="form-check-label" htmlFor="exampleRadios2">
                                        Contains battery / flammables / liquid
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="twobutton">
                    <button className="savedraft">Save As Draft</button>
                    <button className="publishproduct">Publish Product</button>
                </div>
            </Container>
        </div>
    );
};

export default AddProductMobile;